import Cookies from 'js-cookie';

(function() {
    const cookieCounter = document.querySelector('.cookies-counter');
    const products = Array.from(document.querySelectorAll('.btn-compare'));

    if (products.length > 0) {
        const categoryId = products[0].getAttribute('data-product-category');
        const deleteCookies = document.querySelector('.cookies-counter-sidebar');
        let cookies = Cookies.getJSON('compare_products') ? Cookies.getJSON('compare_products') : {};
        let cookiesArrayLength = cookies[categoryId] ? cookies[categoryId].length : 0;

        const checkButtonClass = button => {
            const btn = button.classList;

            if (btn.contains('is-active')) {
                btn.remove('is-active');
            } else {
                btn.add('is-active');
            }
        };

        const isCookieActive = () => {
            if (cookiesArrayLength <= 0) {
                const active = Array.from(document.querySelectorAll('.is-active'));

                cookieCounter.classList.remove('is-visible');

                active.map(item => {
                    item.classList.remove('is-active');
            });
            } else {
                cookies[categoryId].map(product => {
                    products.map(item => {
                    const value = item.getAttribute('data-product');

                if (value === product) {
                    checkButtonClass(item);
                }
            });
            });
                cookieCounter.classList.add('is-visible');
            }
        };

        isCookieActive();

        deleteCookies.addEventListener('click', (event) => {
            event.preventDefault();

            Cookies.remove('compare_products', {path: ''});
            cookies = {};
            cookiesArrayLength = 0;
            isCookieActive();
        });

        const changeCookiesArray = (key, productId, button) => {
            if (key.length < 3) {
                if (key.indexOf(productId) !== -1) {
                    key.map((value, i) => {
                        if (value === productId) {
                        key.splice(i, 1);
                    }
                });
                } else {
                    key.push(productId);
                }
            } else {
                key.map((value, i) => {
                    if (value === productId) {
                    key.splice(i, 1);
                    cookieCounter.querySelector('[data-compare-total]').innerHTML = cookiesArrayLength;
                }
            });
                button.classList.remove('is-active');
            }

            cookiesArrayLength = key.length;
            isCookieActive();
        };

        const makeCookie = item => {
            item.addEventListener('click', (e) => {
                const button = e.currentTarget;
            const attr = button.getAttribute('data-product');
            const key =  button.getAttribute('data-product-category');

            checkButtonClass(button);

            if (key in cookies) {
                const prop = cookies[key];
                changeCookiesArray(prop, attr, item);
            } else {
                cookies[key] = [];
                cookies[key].push(attr);
                cookiesArrayLength = cookies[key].length;
                isCookieActive();
            }

            Cookies.set('compare_products', cookies, {path: ''});
            cookieCounter.querySelector('[data-compare-total]').innerHTML = cookiesArrayLength;
            isCookieActive();
        });
        };

        products.map(makeCookie);
        cookieCounter.querySelector('[data-compare-total]').innerHTML = cookiesArrayLength;
    }
})();
